import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { IAppOnlyStore } from 'stores/AllStores';
import { IActivitiesGroup } from 'common/interfaces/activity';
import { ActivitiesGroup } from 'components/activity';
import { LoadingSpinner } from 'components/indicator';

// Styles
const s = require('./ActivitiesSidebar.css');

// Pages
@inject('store')
@observer
export class ActivitiesSidebar extends React.Component<IAppOnlyStore, {}> {
    constructor(props: any) {
        super(props);
    }

    public render() {

        const { activities } = this.props.store;

        return (
            <div className={s.activitiesSidebar}>
                {
                    !activities.userActivitiesLoading
                        ? activities.activitiesUserLength >= 0
                            ? this.renderActivitiesListByGroup()
                            : null
                        : <LoadingSpinner key="spinner" active={true} className={s.spinner} />
                }
            </div>
        );
    }

    private renderActivitiesListByGroup = () => {
        return this.props.store.activities.userActivitiesGroups.map((group, key) => {
            return group.activities.length > 0 ? (
                <ActivitiesGroup
                    key={group.key}
                    title={group.title}
                    allFinished={group.allFinished}
                    activities={group.activities}
                />
            ) : null;
        });
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/layout/Sidebar/Activities/ActivitiesSidebar.tsx